// External
import React, { useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';

// Internal
import { YearlyGraphPlot, YearlyGraphButtonGroup } from './components';
import YearlySpatialAux from './utils/yearlyspatialaux';
import { ContainerOfPlaceholders } from 'general_components';
import { getUniqueSortedYearsFromDate } from './utils/yearly_aux';
import { productResponseToArrays, axiosCall } from 'general_utils/functions';
import DateManager from 'general_utils/datemanager';
import { general_config } from 'general_utils/general_configuration';

const datemanager = new DateManager();
const yearlyspatialaux = new YearlySpatialAux();

function YearlyComparisonGraph({ catchment: catchmentName, catchmentGeoJson }) {

  const [productName, setProductName] = useState(general_config.default_product);

  /**
   * States for the interactive average calculation
   */
  const [availableWaterYears, setAvailableWaterYears] = useState([])
  const [availableData, setAvailableData] = useState(null);
  const [startYearForAverageCalculation, setStartYearForAverageCalculation] = useState(null);
  const [endYearForAverageCalculation, setEndYearForAverageCalculation] = useState(null);

  yearlyspatialaux.getWaterYearStartAndEndFromGeoJson(catchmentGeoJson);

  useEffect(() => {
    const [toDate, fromDate] = datemanager.getToFrom(datemanager.numOfTotalDays, yearlyspatialaux.water_year_start_month_and_day);
    
    axiosCall({ catchment: catchmentName, productName: productName.toLowerCase(), to: toDate, from: fromDate })
      .then(res => productResponseToArrays(res))
      .then(([...response]) => {
        const availableDates = response[0];
        const availableValues = (productName.toLowerCase() !== 'swevolume' ? response[1] : response[1].map(value => (value / 1000000).toFixed(2))); // Convert swevolume to mio m
        setAvailableData({'dates': availableDates , 'values' : availableValues});
        
        // Get available years based on the current data
        const availableYears = getUniqueSortedYearsFromDate(availableDates);

        // Create an array with the available water years (bigger number of each season)
        setAvailableWaterYears(DateManager.getWaterYearsArray(yearlyspatialaux.water_year_start_month_and_day, availableYears.length));

      });
  }, [productName]);
  
  if (!availableData) {
    return (
      <ContainerOfPlaceholders
        numOfPlaceholders={10}
      />
    )

  } else {

    return (
      <Row>
        <YearlyGraphButtonGroup
          startYearForAverageCalculation={startYearForAverageCalculation}
          endYearForAverageCalculation={endYearForAverageCalculation}
          setStartYearForAverageCalculation={setStartYearForAverageCalculation}
          setEndYearForAverageCalculation={setEndYearForAverageCalculation}
          availableWaterYears={availableWaterYears}
          setProductName={setProductName}
          productName={productName}
          catchmentName={catchmentName}
          availableDates={availableData['dates']}
          availableValues={availableData['values']}
          numberOfYearsAvailable={availableWaterYears.length - 1}
        />
        <YearlyGraphPlot
          startYearForAverageCalculation={startYearForAverageCalculation}
          endYearForAverageCalculation={endYearForAverageCalculation}
          waterYearStart = {yearlyspatialaux.water_year_start_month_and_day}
          availableDates={availableData['dates']}
          availableValues={availableData['values']}
          productName={productName}
          availableWaterYears={availableWaterYears}
        />
      </Row>
    )
  }
}

export default YearlyComparisonGraph;